import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
import { Deprecated } from '../Deprecated';
var TextItalicIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M30.1199 15.6299L29.9299 16.46C29.5945 16.4801 29.2606 16.5203 28.9299 16.5801C28.6125 16.6213 28.2985 16.6848 27.99 16.77C27.6861 16.843 27.4173 17.0198 27.23 17.27C27.0798 17.5003 26.9682 17.7537 26.8999 18.02L23.8999 31.1499C23.8923 31.2164 23.8923 31.2836 23.8999 31.3501C23.8952 31.4167 23.8952 31.4835 23.8999 31.55C23.8945 31.7213 23.9361 31.8907 24.02 32.04C24.1381 32.1993 24.297 32.3236 24.48 32.3999C24.7499 32.4943 25.0277 32.5648 25.3101 32.6101C25.7401 32.6901 26.0601 32.73 26.3101 32.75L26.1199 33.5901H18.02L18.21 32.75L19.21 32.6699C19.5284 32.6605 19.8443 32.6102 20.1499 32.52C20.4358 32.4255 20.6913 32.2564 20.8899 32.03C21.0659 31.8135 21.1831 31.5551 21.23 31.28L24.23 18.1499C24.2339 18.0733 24.2339 17.9965 24.23 17.9199C24.235 17.8433 24.235 17.7665 24.23 17.6899C24.2329 17.5361 24.1948 17.3844 24.1199 17.25C24.007 17.0921 23.8507 16.9704 23.6699 16.8999C23.3697 16.7766 23.0583 16.683 22.74 16.6201C22.4564 16.5513 22.1692 16.4978 21.8799 16.46L22.0701 15.6299H30.1199Z"
  }));
});
TextItalicIcon.displayName = 'TextItalicIcon';
TextItalicIcon.defaultProps = {
  'aria-label': 'Text Italic'
};
/**
 * @deprecated Use ItalicIcon instead.
 */

export default Deprecated(TextItalicIcon, 'Use ItalicIcon instead.');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/TextItalicIcon/index.js
// module id = 1955
// module chunks = 12